import { useAssociatedProductsStore } from '../stores/associatedProductsStore';

export const useAssociatedProducts = () => {
  const associatedProducts = useAssociatedProductsStore(
    (state) => state.associatedProducts
  );
  const addAssociatedProducts = useAssociatedProductsStore(
    (state) => state.addAssociatedProducts
  );
  const clearAssociatedProducts = useAssociatedProductsStore(
    (state) => state.clearAssociatedProducts
  );
  const isAssociatedProductsLoaded = useAssociatedProductsStore((state) =>
    state.isAssociatedProductsLoaded()
  );
  const updateAssociatedProducts = useAssociatedProductsStore(
    (state) => state.updateAssociatedProducts
  );

  const removeAssociatedProduct = useAssociatedProductsStore(
    (state) => state.removeAssociatedProduct
  );

  return {
    associatedProducts,
    isLoaded: isAssociatedProductsLoaded,
    addAssociatedProducts,
    clearAssociatedProducts,
    updateAssociatedProducts,
    removeAssociatedProduct,
  };
};
